import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import '../public/assets/css/style.css';
import '../public/assets/css/responsive.css';
import './index.css';

// Defer Bootstrap JS so it does not compete with first paint (navbar still works after load)
if (typeof window !== 'undefined') {
  const loadBootstrap = () => import('bootstrap/dist/js/bootstrap.bundle.min.js');
  if (document.readyState === 'complete') {
    loadBootstrap();
  } else {
    window.addEventListener('load', loadBootstrap, { once: true });
  }
}

createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <App />
  </BrowserRouter>
  // </React.StrictMode>
)